/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../features/dashboard/dashboardSettings/DashboardSettingsAPI'], (DashboardSettingsAPI) => {
	/**
	 * @class DashboardSettingsService
	 * @implements {@link DashboardSettingsAPI}
	 * @hideconstructor
	 * @classdesc Glass service providing an implementation of {@link DashboardSettingsAPI}
	 */
	class DashboardSettingsService extends DashboardSettingsAPI {

		constructor() {
			super();
			this._performanceEnabled = false;
		}

		_initializePerformance(glassContext) {
			const keys = [
				'DISP.zipi.IPAEnabled',
				'zipi.IPAEnabled'
			];
			const configGlassService = glassContext.getCoreSvc('.Config');
			return Promise
				.all(keys.map(key => configGlassService.getConfigValue(key)))
				.then(values => values.indexOf('true') !== -1)
				.then(isEnabled => {
					this._performanceEnabled = isEnabled;
				});
		}

		initialize(glassContext) {
			this._glassContext = glassContext;
			return this._initializePerformance(glassContext);
		}

		getAPI() {
			return this;
		}

		get(settingName) {
			let setting;
			if (settingName === 'toolbarContainer' || settingName === 'odtToolbarContainer') {
				setting = this._getODTToolbarContainer();
			} else if (settingName === 'panelToolbarContainer') {
				setting = this._getPanelToolbarContainer();
			} else if (settingName === 'performanceEnabled') {
				setting = this._performanceEnabled;
			}
			return setting;
		}

		/**
		 * @private
		 * Retrieves the toolbar container defined in the dashboard application perspective
		 * Glass uses the elementId in a selector id query, need to escape the css special characters (or have glass do it...)
		 */
		_getODTToolbarContainer() {
			return this._glassContext.findElement('com\\.ibm\\.bi\\.dashboard\\.toolbars\\.toolbarContainer');
		}

		_getPanelToolbarContainer() {
			return this._glassContext.findElement('com\\.ibm\\.bi\\.dashboard\\.toolbars\\.toolbarPanelContainer');
		}
	}
	return DashboardSettingsService;
});
